import { Injectable, inject } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { ToastService } from '@web/shared/ui';
import { AdminCartSettingsFormData } from '../models/admin-cart-settings-form-data';
import { AdminCartApiService } from '../api/services/admin-cart-api.service';
import { AdminCartSettingsUpdateRequest } from '../api/requests/admin-cart-settings-update.request';

@Injectable({
  providedIn: 'root',
})
export class AdminCartDataSourceService {
  private readonly cartApi = inject(AdminCartApiService);
  private readonly toast = inject(ToastService);

  public fetchSettingsFormData(): Observable<AdminCartSettingsFormData> {
    return this.cartApi.fetchSettings({ skipByLoading: true }).pipe(
      map(
        (response) =>
          new AdminCartSettingsFormData({
            deleteCartAfterCheckout: response.deleteCartAfterCheckout,
          }),
      ),
    );
  }

  public updateSettingsByFormData(
    data: AdminCartSettingsFormData,
  ): Observable<void> {
    return this.cartApi
      .updateSettings(
        new AdminCartSettingsUpdateRequest({
          deleteCartAfterCheckout: data.deleteCartAfterCheckout,
        }),
      )
      .pipe(
        tap(() => {
          this.toast.show((builder) =>
            builder
              .initSuccess('Konfiguracja koszyka została zaktualizowana.')
              .build(),
          );
        }),
      );
  }
}
